import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import LightGreenButton from '../Buttons/LightGreenButton';
import s from './NotFoundPage.module.css';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <section className={s.wrapper} aria-labelledby="not-found-title">
      <div className={s.card}>
        <div className={s.illustration} aria-hidden="true">
          <span className={s.code}>404</span>
        </div>
        <h1 id="not-found-title" className={s.title}>
          {t('Сторінку не знайдено')}
        </h1>
        <p className={s.description}>
          {t(
            'Такої сторінки не існує або вона була переміщена. Перевірте коректність адреси або поверніться на головну.',
          )}
        </p>
        <div className={s.actions}>
          <button type="button" className={s.secondaryButton} onClick={handleGoBack}>
            {t('Повернутися назад')}
          </button>
          <LightGreenButton
            onClick={handleGoHome}
            text={t('Повернутися на головну')}
            type="button"
            className={s.primaryButton}
          />
        </div>
      </div>
    </section>
  );
};

export default NotFoundPage;
